import { render, staticRenderFns } from "./ProjectAnnounce.vue?vue&type=template&id=5ba4f35c&scoped=true&"
import script from "./ProjectAnnounce.vue?vue&type=script&lang=js&"
export * from "./ProjectAnnounce.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAnnounce.vue?vue&type=style&index=0&id=5ba4f35c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba4f35c",
  null
  
)

export default component.exports